import axios from "axios";
import qs from "qs";
import {Toast} from "mint-ui";
import store from "@/store/store";
import {URL5} from "@/libsV2/urlApi";
import oAes from "@/libsV2/encryption";
import storage from "@/libsV2/storage";
import router from "../router";

const disableAes = true;

/**
 * 接口错误上报
 * @param url
 * @param params
 * @param res
 */
function reportErr(url, params, res) {
    if (window.location.host != 'aosmithv2.iwxapi.com') {
        return
    }
    let oParams = ''
    if (typeof params == 'string') {
        let arr = params.split('&')
        let obj = {}
        arr.map(item => {
            obj[item.split('=')[0]] = item.split('=')[1] || ''
        })
        oParams = JSON.stringify(obj)
    } else if (typeof params == 'object') {
        oParams = JSON.stringify(params)
    }
    let param = "&type=0";
    param += "&url=" + encodeURIComponent(window.location.href);
    param += "&host=" + window.location.host;
    param += "&request_url=" + url;
    param += "&query=" + oParams;
    param += "&api_error=" + JSON.stringify(res.error || {});
    param += "&data=" + JSON.stringify(res || {});
    let errURL = "https://web-error.cn-beijing.log.aliyuncs.com/logstores/aosmith/track_ua.gif?APIVersion=0.6.0" + param;
    let logstores = new Image()
    logstores.src = errURL;
    logstores = null
}


export const requestAesPost5 = (url, data = {}, disable) => {

    const obj = Object.assign({}, data, {
        channel: 1,
        source: data.app ? 'app' : 'h5',
        _req_url: router.currentRoute.path,
        token: storage.getStorage('token') || ''
    });
    const isDisable = typeof disable == 'boolean' ? disable : disableAes;

    return new Promise((resolve, recject) => {

        const encryptionData = {
            data: encodeURI(oAes.Encrypt(JSON.stringify(obj))),
            time: oAes.nowTime,
        };
        // post请求
        axios.post(URL5 + url, qs.stringify(isDisable ? obj : encryptionData), {
            headers: isDisable ? undefined : {
                'content-type': 'application/x-www-form-urlencoded', // 默认值
                'sign': oAes.productionToken(obj),//加密需开启
            },
        }).then(res => {
            if (res.data.error === 0) {
                // 解密
                if (!isDisable) {
                    //解密
                    res.data.data.result = JSON.parse(oAes.Decrypt(res.data.data.result));
                }
                //异步操作完成 返回结果
                resolve(res)
            } else {
                reportErr(url, obj, res.data)
                Toast({
                    message: res.data.msg,
                    duration: 500
                });
                recject(res)
                store.commit('loadSwitch', false);
            }
        }).catch((err) => {
            Toast({
                message: url + "错误",
                position: 'bottom',
                duration: 1200
            })
        })
    })
}

